/* tp-sabores — troca de sabor na PDP sem reload.
   Busca a PDP do produto linkado e substitui o conteúdo de <product-info>. */

if (!customElements.get('tp-sabores')) {
  class TpSabores extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      this.addEventListener('click', this.handleClick.bind(this));
    }

    async handleClick(event) {
      const item = event.target.closest('.tp-sabores__item');
      if (!item || !this.contains(item)) return;

      const url = item.dataset.productUrl;
      if (!url) return;

      event.preventDefault();

      if (item.classList.contains('tp-sabores__item--active')) return;

      this.setLoading(true);

      try {
        const response = await fetch(url, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

        const newProductInfo = doc.querySelector('product-info');
        const currentProductInfo = this.closest('product-info') || document.querySelector('product-info');

        if (!newProductInfo || !currentProductInfo) throw new Error('product-info not found');

        history.replaceState({}, '', url);

        currentProductInfo.innerHTML = newProductInfo.innerHTML;

        Array.from(newProductInfo.attributes).forEach((attr) => {
          currentProductInfo.setAttribute(attr.name, attr.value);
        });

        // Re-executa os scripts que vieram no HTML novo (innerHTML não roda script)
        currentProductInfo.querySelectorAll('script').forEach((oldScript) => {
          const newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach((attr) => {
            newScript.setAttribute(attr.name, attr.value);
          });
          newScript.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });

        if (window.Shopify && window.Shopify.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }

        const newTitle = doc.querySelector('title');
        if (newTitle) document.title = newTitle.textContent;
      } catch (error) {
        console.error('[tp-sabores] erro ao carregar produto:', error);
        window.location.href = url;
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(isLoading) {
      // Se o innerHTML do product-info já foi trocado, este nó está órfão:
      // procura o elemento vivo no documento.
      const host = this.isConnected ? this : document.querySelector('tp-sabores');
      if (!host) return;

      host.classList.toggle('tp-sabores--loading', isLoading);

      const overlay = host.querySelector('.tp-sabores__overlay');
      if (!overlay) return;

      overlay.classList.toggle('tp-sabores__overlay--visible', isLoading);

      const spinner = overlay.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !isLoading);
    }
  }

  customElements.define('tp-sabores', TpSabores);
}
